import { useSessionStorage } from "@vueuse/core";
import { onMounted, watch } from "vue";

export interface DebugBannerPayload {
  label: string;
  value: string | number | boolean;
}

export const useDebugBanner = () => {
  const enableDebug = useSessionStorage("enable-debug", false);

  const createBannerWrapper = () => {
    const bannerWrapper = document.createElement("div");
    bannerWrapper.classList.add(
      "fixed",
      "bottom-4",
      "right-4",
      "z-9999",
      "flex",
      "flex-col",
      "gap-2",
    );
    bannerWrapper.id = "debug-banner-wrapper";

    if (!document.getElementById("debug-banner-wrapper")) {
      document.body.appendChild(bannerWrapper);
    }

    bannerWrapper.addEventListener("click", handleBannerClick);
  };

  const showBanner = (area: string, payload: DebugBannerPayload[]) => {
    const banner = document.createElement("div");
    banner.classList.add(
      "bg-surface-level-1",
      "p-2",
      "rounded-md",
      "shadow-md",
      "border-4",
      "border-error",
    );
    banner.dataset.debugBanner = "";
    banner.innerHTML = `
      <p class="text-xs font-semibold">[DEBUG:${area}]</p>
      <ul class="text-xs whitespace-nowrap">
        ${payload
          .map((item) => `<li><b>${item.label}</b>: ${item.value}</li>`)
          .join("")}
      </ul>
    `;

    const bannerWrapper = document.getElementById("debug-banner-wrapper");
    if (bannerWrapper) {
      bannerWrapper.appendChild(banner);

      setTimeout(() => {
        banner.remove();
      }, 5000);
    }
  };

  const handleBannerClick = (event: Event) => {
    const target = (event.target as HTMLElement).closest("[data-debug-banner]");

    if (target) {
      target.remove();
    }
  };

  watch(enableDebug, (val) => {
    if (val) {
      createBannerWrapper();
    }
  });

  onMounted(() => {
    if (enableDebug.value) {
      createBannerWrapper();
    }
  });

  return {
    enableDebug,
    showBanner,
  };
};
